export default __webpack_public_path__ + "static/media/angels (1).442929e2.png";